<!-- 输入信息 -->

<template>
    <views class="input-info">
        <nav-bar
            :title="name"
            fixed
            theme="white"
            @click-left="onClickLeft">
        </nav-bar>
        <images :src="imgs.bg"></images>
        <views class="input-info-content">
            <images :src="imgs.contentBg"></images>
            <views class="inner">
                <views class="con">
                    <views
                        v-for="(item, index) in items"
                        :key="index">
                        <input-info-item v-model="items[index]"></input-info-item>
                    </views>
                    <views class="input-info-list">
                        <button :disabled="value" @click="handleSubmit">提交</button>
                    </views>
                </views>
            </views>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import InputInfoItem from './InputInfoItem'
import tools from '@/mixins/tools'
export default {
    mixins: [tools],
    components: {
        NavBar,
        InputInfoItem
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        imgs: {
            type: Object,
            default: () => ({})
        },
        customList: {
            type: Array,
            default: () => []
        },
        name: {
            type: String,
            default: '抽奖'
        }
    },
    data() {
        return {
            items: []
        }
    },
    watch: {
        customList: {
            handler(val) {
                this.items = val
            },
            immediate: false
        }
    },
    methods: {
        onClickLeft() {
            this.push('/')
        },
        handleSubmit() {
            this.$emit('save', this.items)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
